/** @jsxImportSource @emotion/react */
import FormLabel from '@mui/material/FormLabel'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { FieldRenderProps } from 'react-final-form'
import * as classes from './styles'

function SignInInput({
  input,
  meta: { touched, error, submitError, submitting },
  type,
  label,
  placeholder,
  startAdornment,
  endAdornment,
  ...props
}: FieldRenderProps<string, HTMLElement>) {
  return (
    <>
      <FormLabel css={classes.inputLabelWrapper} htmlFor={input.name}>
        <Typography variant="body2" css={classes.inputLabel}>
          {label}
        </Typography>
      </FormLabel>

      <TextField
        css={classes.input}
        fullWidth
        type={type}
        error={!!((touched || submitting) && (error || submitError))}
        autoCorrect="off"
        spellCheck="false"
        helperText={(touched || submitting) && (error || submitError) ? error || submitError : ''}
        placeholder={placeholder}
        id={label ? input.name : undefined}
        {...input}
        {...props}
        slotProps={{
          input: {
            startAdornment: startAdornment,
            endAdornment: endAdornment,
          },
        }}
      />
    </>
  )
}

export default SignInInput
